<template>
  <CardContainer>
    <slot name="icon">
      <v-icon v-if="item.icon" class="mb-4">{{ item.icon }}</v-icon>
      <img
        v-else-if="item.image"
        :src="item.image"
        class="mb-4"
        style="width: 40px; height: 40px; object-fit: contain"
      />
    </slot>
    <span class="body-bold-xlarge neutral-20-dark--text mb-1"
      >{{ item.percentage }}%</span
    >
    <div class="d-flex align-center mb-1">
      <span class="circle mr-1" :style="{ backgroundColor: item.color }" />
      <span class="body-label-caption neutral-40-light--text text-truncate">{{
        item.name
      }}</span>
      <v-tooltip v-if="item.tooltip" max-width="200px" top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-on="on"
            v-bind="attrs"
            size="12"
            class="ml-1 neutral-70--text"
            style="margin-bottom: 2px"
          >
            mdi-information
          </v-icon>
        </template>
        <span>{{ item.tooltip }}</span>
      </v-tooltip>
    </div>
    <span class="body-regular-smaller neutral-40-light--text"
      >{{ formatAboveThousand(item.play) }} plays</span
    >
  </CardContainer>
</template>

<script>
import CardContainer from '../Base/CardContainer.vue'
export default {
  name: 'CardItem',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        name: 'Desktop',
        color: '#3F55EE',
        icon: 'mdi-monitor',
        views: 344,
        percentage: 93.99,
        tooltip: false,
      }),
    },
  },
  components: {
    CardContainer,
  },
  methods: {
    formatAboveThousand(value) {
      const format = this.$i18next.resolvedLanguage === 'en' ? 'en-US' : 'pt-BR'
      return value?.toLocaleString(format)
    },
  },
}
</script>

<style scoped lang="scss">
.circle {
  width: 12px !important;
  height: 12px !important;
  min-width: 12px !important;
  min-height: 12px !important;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 2px;
}
</style>
